import { render, staticRenderFns } from "./TradeShipments.vue?vue&type=template&id=6f2a6fd4&scoped=true&"
import script from "./TradeShipments.vue?vue&type=script&lang=js&"
export * from "./TradeShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a6fd4",
  null
  
)

export default component.exports